// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

export default {
  getCalculateDeliveryCharge(payload) {
    return OperationRepository.get('merchant/calculator/calculate-delivery-charge', {
      params: payload,
    })
  },
}
